import { Component } from "@angular/core";
import { AppCommonModule } from "@app/components/app.common.module";
import { ClientFormModalWrapperComponent } from "@app/components/client-form-modal-wrapper/client-form-modal-wrapper.component";

@Component({
  selector: 'app-client-form-modal-mobile',
  standalone: true,
  imports: [AppCommonModule],
  templateUrl: './client-form-modal-mobile.component.html',
  styleUrl: './client-form-modal-mobile.component.scss'
})
export class ClientFormModalMobileComponent extends ClientFormModalWrapperComponent {

}
